import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import ElaLogo from './ElaLogo';

export default function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);

  const openCalendly = (e) => {
    e.preventDefault();
    setMenuOpen(false);
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/i-elashapira/idea-reality-check?primary_color=f52e72',
      });
    }
  };

  return (
    <>
      <nav className="site-nav">
        <Link to="/" className="nav-logo">
          <ElaLogo width="9vh" height="3vh" />
          <h6>Ideas Worth Building</h6>
        </Link>

        <ul className="nav-links">
          <li><NavLink to="/nursery">The Nursery</NavLink></li>
          <li><NavLink to="/vision">The Vision</NavLink></li>
          <li><NavLink to="/portfolio">Portfolio</NavLink></li>
          <li><NavLink to="/about">About Us</NavLink></li>
          <li><NavLink to="/contact">Contact</NavLink></li>
          <li>
            <a href="/" className="nav-cta" onClick={openCalendly}>
              Book a Call
            </a>
          </li>
        </ul>

        {/* Hamburger */}
        <button
          className="nav-hamburger"
          onClick={() => setMenuOpen(true)}
          aria-label="Open menu"
        >
          <svg width="24" height="18" viewBox="0 0 24 18">
            <line x1="0" y1="1" x2="24" y2="1" stroke="#000" strokeWidth="2"/>
            <line x1="0" y1="9" x2="24" y2="9" stroke="#000" strokeWidth="2"/>
            <line x1="0" y1="17" x2="24" y2="17" stroke="#000" strokeWidth="2"/>
          </svg>
        </button>
      </nav>

      {/* Mobile menu overlay */}
      <div className={`nav-mobile-menu ${menuOpen ? 'open' : ''}`}>
        <button
          className="nav-mobile-close"
          onClick={() => setMenuOpen(false)}
          aria-label="Close menu"
        >
          ×
        </button>
        <NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink>
        <NavLink to="/nursery" onClick={() => setMenuOpen(false)}>The Nursery</NavLink>
        <NavLink to="/vision" onClick={() => setMenuOpen(false)}>The Vision</NavLink>
        <NavLink to="/portfolio" onClick={() => setMenuOpen(false)}>Portfolio</NavLink>
        <NavLink to="/about" onClick={() => setMenuOpen(false)}>About Us</NavLink>
        <NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact</NavLink>
        <a href="/" onClick={openCalendly}>Book a Call</a>
      </div>
    </>
  );
}
